import React, { Fragment, useContext, useEffect, useState } from 'react';

const GroupContainer: React.FC<any> = (props) => {
  const { property } = props;

  return <></>;
};

export default GroupContainer;
